import { Member } from "../types/apiResponses";
import { Permissions } from "../constants/api";

function hasPermissions(member: Member, permissions: Permissions[]): boolean {
  return permissions.some((p) => p === member.permissions);
}

export default hasPermissions;
